import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { middleware as cacheMiddleware } from './redux-cache';
export var storeWithData = function storeWithData(reducer) {
  var additionalThunkArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var middlewares = [thunkMiddleware.withExtraArgument(additionalThunkArguments), cacheMiddleware];

  // Get the Redux Devtools plugin for Chrome (http://bit.ly/1KKdNQs),
  // run `npm run build:dev` (or `npm run build:watch`) and debug redux
  // state changes
  var composeEnhancers = (process.env.NODE_ENV === 'development' || window.location.hostname.match(/\.staging\./g)) && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
  var middleware = composeEnhancers(applyMiddleware.apply(void 0, middlewares));
  return createStore(reducer, middleware);
};
export default storeWithData;